export const ModelDetail = ({ message }) => {
    const isHuman = message.type === 'human';
    const details = [];
    if (message.model) {
        details.push(message.model);

        if (message.modelKwargs) {
            const modelKwargs = JSON.parse(message.modelKwargs);
            for (const modelKwarg in modelKwargs) {
                let detail = `  ${modelKwarg}: `;
                detail += modelKwarg==='stop_sequences' ? JSON.stringify(modelKwargs[modelKwarg]) : modelKwargs[modelKwarg];
                details.push(detail);
            }
            details.push('');
        }
    }

    if (message.tokens) {
        const tokenType = isHuman ? 'Input' : 'Output';
        details.push(`${tokenType} tokens consumed: ${message.tokens}`);
    }

    if (message.duration) {
        details.push('LLM processing time: ' + message.duration + 's');
    }

    if (isHuman && message.unresolvedPromptTemplate) {
        details.push(`\nUnresolved prompt template:\n  ${message.unresolvedPromptTemplate.replaceAll('\\n', '\n').replaceAll('\n', '\n  ')}`);
    }

    const detail = details.join('\n');

    return (
        <pre className="code-pre">
            <div className="modelDetailDiv">
                <code className="language-json">
                    {detail}
                </code>
            </div>
        </pre>
    );
};
